import React, { useState } from "react";
import {
  AppBar,
  Avatar,
  Toolbar,
  Drawer,
  Box,
  Typography,
  IconButton,
  Stack,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
  Divider,
} from "@mui/material";
import AppsIcon from "@mui/icons-material/Apps";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import avatar from "./../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import {
  userMenus,
  adminMenus,
  prakashakMenus,
  passcodeMenus,
} from "../route/SidebarMenu";
import {
  setEncryptedItem,
  getDecryptedItem,
  removeItem,
} from "../utils/storageUtils";

function MuiDrawer() {
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const userType = getDecryptedItem("usertype");
  const defaultMenus =
    userType === "mis"
      ? userMenus
      : userType === "admin"
      ? adminMenus
      : userType === "prakashak"
      ? prakashakMenus
      : userType === "passcode"
      ? passcodeMenus
      : [];
  const [filteredMenu, setFilteredMenu] = useState(defaultMenus);
  const [searchText, setSearchText] = useState("");

  const searchTextOnChange = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchText(query);
    if (query) {
      const results = defaultMenus.filter((item) =>
        item.text.toLowerCase().includes(query)
      );
      setFilteredMenu(results);
    } else {
      setFilteredMenu(defaultMenus);
    }
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    setSearchText("");
    setFilteredMenu(defaultMenus); // Reset the menu when drawer closes
  };

  return (
    <>
      {/* Menu Icon Button */}
      <IconButton
        onClick={() => setIsDrawerOpen(true)}
        size="large"
        edge="start"
        color="inherit"
        aria-label="menu"
        sx={{ color: "#ffffff" }}
      >
        <MenuIcon />
      </IconButton>

      {/* Drawer */}
      <Drawer
        anchor="left"
        open={isDrawerOpen}
        onClose={handleDrawerClose}
        PaperProps={{
          style: {
            background: "linear-gradient(135deg, #e3f2fd, #ffffff)",
            boxShadow: "0px 6px 30px rgba(0, 0, 0, 0.1)",
            borderTopRightRadius: "16px",
            borderBottomRightRadius: "16px",
            width: "360px",
          },
        }}
      >
        {/* Drawer Header */}
        <AppBar
          position="relative"
          elevation={0}
          style={{
            backgroundColor: "#1976d2",
            color: "#ffffff",
            borderTopRightRadius: "16px",
          }}
        >
          <Toolbar>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <Avatar alt="Logo" src={avatar} sx={{ width: 40, height: 40 }} />
              <Typography variant="h6" fontWeight="600" noWrap>
                ThinkZone
              </Typography>
              <IconButton onClick={handleDrawerClose} style={{ color: "#fff" }}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </Toolbar>
        </AppBar>

        {/* Search Box */}
        {/* <Box px={3} py={2}>
          <TextField
            fullWidth
            placeholder="Search menus..."
            variant="outlined"
            value={searchText}
            onChange={searchTextOnChange}
            InputProps={{
              style: {
                background: "#eef0f3",
                borderRadius: "12px",
                padding: "4px 8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              },
              startAdornment: (
                <SearchIcon style={{ marginRight: "8px", color: "#9e9e9e" }} />
              ),
            }}
          />
        </Box> */}

        {/* <Divider style={{ margin: "16px 0" }} /> */}

        {/* Menu List */}
        <Box style={{ height: "calc(100vh - 120px)", overflowY: "auto" }}>
          <List>
            {filteredMenu.map((menu) => (
              <ListItem key={menu.text} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate(menu.navigateTo);
                    handleDrawerClose();
                  }}
                  style={{
                    padding: "12px 16px",
                    borderRadius: "8px",
                    margin: "4px 0",
                    transition: "background 0.3s ease-in-out",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e3f2fd")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                >
                  <ListItemIcon>
                    <AppsIcon style={{ color: "#1976d2" }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={menu.text}
                    primaryTypographyProps={{
                      fontWeight: "500",
                      fontSize: "15px",
                      color: "#333",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
}

export default MuiDrawer;
